import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import useLenis from "./lib/useLenis";
import { ClientAuthProvider, RequireClient } from "./lib/auth";

import Home from "./pages/Home";
import FrameworkPage from "./pages/FrameworkPage";
import SchoolsPage from "./pages/SchoolsPage";
import LibrariesPage from "./pages/LibrariesPage";
import PlatformPage from "./pages/PlatformPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PricingPage from "./pages/PricingPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import ChecklistPage from "./pages/ChecklistPage";
import EquipmentPage from "./pages/EquipmentPage";
import CertificationPage from "./pages/CertificationPage";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SolutionsIndex from "./pages/SolutionsIndex";
import SolutionDetail from "./pages/SolutionDetail";
import AdminPage from "./pages/AdminPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function LenisWrapper({ children }) {
  useLenis();
  return children;
}

function App() {
  return (
    <div className="App bg-white">
      <BrowserRouter>
        <ClientAuthProvider>
        <LenisWrapper>
          <ScrollToTop />
          <Header />
          <main data-testid="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/solutions" element={<SolutionsIndex />} />
              <Route path="/solutions/:slug" element={<SolutionDetail />} />
              <Route path="/framework" element={<FrameworkPage />} />
              <Route path="/schools" element={<SchoolsPage />} />
              <Route path="/libraries" element={<LibrariesPage />} />
              <Route path="/platform" element={<Navigate to="/solutions/platform" replace />} />
              <Route path="/case-studies" element={<CaseStudiesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/checklist" element={<RequireClient><ChecklistPage /></RequireClient>} />
              <Route path="/equipment" element={<RequireClient><EquipmentPage /></RequireClient>} />
              <Route path="/certification" element={<RequireClient><CertificationPage /></RequireClient>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="top-right"
            richColors
            toastOptions={{
              style: {
                border: "2px solid #1A1A1A",
                borderRadius: "16px",
                fontFamily: "DM Sans, sans-serif",
                fontWeight: 600,
              },
            }}
          />
        </LenisWrapper>
        </ClientAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
